package com.wintermar.inspection.feature.presentation.inspection.landing

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import com.wintermar.inspection.core.ui.util.SelectionModel
import com.wintermar.inspection.feature.domain.model.VesselModel
import com.wintermar.inspection.feature.domain.model.inspection.InspectionLandingModel
import com.wintermar.inspection.feature.domain.model.inspection.InspectionModel
import com.wintermar.inspection.feature.domain.model.template.TemplateOptionModel
import com.wintermar.inspection.graphql.type.InspectionStatus

class InspectionLandingState(
    private val onGetData: (page: Int, isRefreshData: Boolean) -> Unit,
    private val onCreateNewInspection: (templateId: String, templateName: String) -> Unit,
    private val onShowSuccessToast: (message: String) -> Unit,
    private val onGetInspectionDetail: (inspectionId: String) -> Unit,
    private val onTriggerRetrySubmit: () -> Unit,
    private val onDeleteInspection: (inspectionId: String) -> Unit,
    private val onEditInspectionWithStatusComplete: (inspectionId: String) -> Unit
) {
    var isLoading by mutableStateOf(false)
    var isLoadingInspectionDetail by mutableStateOf(false)
    var isLoadingStartInspection by mutableStateOf(false)
    var isLoadingLoadMore by mutableStateOf(false)
    var isRefreshing by mutableStateOf(false)
    var hasMoreData by mutableStateOf(true)
    var page: Int by mutableStateOf(1)
    var data by mutableStateOf(InspectionLandingModel())
    var showActionModal by mutableStateOf(false)
    var showActionConfirmationModal by mutableStateOf(false)
    var showInspectionDetailModal by mutableStateOf(false)
    var actionData by mutableStateOf<InspectionModel?>(null)
    var templates by mutableStateOf(emptyList<SelectionModel>())
    var templateOptions by mutableStateOf(listOf<TemplateOptionModel>())
    var vesselList by mutableStateOf(listOf<VesselModel>())

    fun updateProgress(inspection: InspectionModel, showSuccessUpdateToast: Boolean) {
        val inspectionIndex = data.data.indexOfFirst { it.id == inspection.id }
        if (inspectionIndex == -1) {
            return
        }

        val newData = data.data.toMutableList()
        newData[inspectionIndex] = data.data[inspectionIndex].copy(
            lastUpdated = inspection.lastUpdated,
            vesselName = inspection.vesselName,
            totalAnswer = inspection.totalAnswer,
            totalQuestion = inspection.totalQuestion,
            status = if (inspection.status == InspectionStatus.UNKNOWN__) data.data[inspectionIndex].status
            else inspection.status
        )

        data = data.copy(
            data = newData
        )

        if (showSuccessUpdateToast) {
            onShowSuccessToast(
                "Progress for Inspection ${newData[inspectionIndex].templateName} saved"
            )
        }
        onTriggerRetrySubmit()
    }

    fun onShowActionModal(show: Boolean, inspection: InspectionModel? = null) {
        showActionModal = show
        actionData = inspection
    }

    fun onShowActionConfirmationModal(show: Boolean, inspection: InspectionModel? = null) {
        showActionConfirmationModal = show
        actionData = inspection
    }

    fun onStartInspection(templateId: String, templateName: String) {
        onCreateNewInspection(templateId, templateName)
    }

    fun onDelete(inspectionId: String) {
        onDeleteInspection(inspectionId)
    }

    fun onItemClick(inspectionId: String) {
        onGetInspectionDetail(inspectionId)
    }

    fun onShowInspectionDetailModal(show: Boolean, inspection: InspectionModel? = null) {
        actionData = inspection
        showInspectionDetailModal = show
    }

    fun loadMore() {
        onGetData(page, false)
    }

    fun onRefresh() {
        page = 1
        isRefreshing = true
        onGetData(page, isRefreshing)
    }

    fun onExcludeInspectionId(inspectionId: String) {
        val excludeData = data.data.find { it.id == inspectionId }
        val vesselNameMessage =
            if (excludeData?.vesselName?.isNotEmpty() == true) " for ${excludeData.vesselName}" else ""
        val name = "${excludeData?.templateName}${vesselNameMessage}"
        if (name.isEmpty() || name == "null") return

        onShowSuccessToast(
            "$name approved and sent. Track progress via VDLP in Wintermar Hub"
        )
        data = data.copy(
            data = data.data.filter { it.id != inspectionId }
        )
    }

    fun onEditWithStatusComplete(inspectionId: String) {
        onEditInspectionWithStatusComplete(inspectionId)
    }
}
